var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{attrs:{"icon":_vm.icon,"href":_vm.href,"target":_vm.target,"type":_vm.type,"underline":_vm.underline,"disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }